import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import { ToastContainer } from 'react-toastify';
import '@sweetalert2/theme-material-ui';
import './App.css';
import { AuthProvider } from './lib/auth';


function App() {
 
return (
     <AuthProvider>
      <AppProvider>
        <AppRoutes />
        <ToastContainer />
      </AppProvider>
    </AuthProvider>
  );
}

export default App;



